<template>
  <div id="app" class="page full-height" :is="layout">
    <router-view/>
  </div>
</template>

<script>
const defaultLayout = 'default'

export default {
  computed: {
    layout () {
      return `${(this.$route.meta.layout || defaultLayout)}-layout`
    }
  }
}
</script>

<style lang="scss">
@import './assets/scss/app.scss';
</style>
